import CustomButton from "common/components/Button/Button"
import createImgURI from "common/utils/createImgURI"
import {
  catalogosSelector,
  manyArticulosSelectedSelector,
} from "features/Inventario/redux/selectors/catalogosSelector"
import { deleteArticuloFromCategoriaSelected } from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Button } from "primereact/button"
import React, { useCallback, useEffect } from "react"
import { CameraOff } from "react-feather"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const ArticuloSelected = React.memo(
  ({
    // @ts-expect-error TS(2339): Property 'thumbnailBase64' does not exist on type ...
    thumbnailBase64,
    // @ts-expect-error TS(2339): Property 'fichero' does not exist on type '{}'.
    fichero,
    // @ts-expect-error TS(2339): Property 'concepto' does not exist on type '{}'.
    concepto,
    // @ts-expect-error TS(2339): Property 'categoriaName' does not exist on type '{...
    categoriaName,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id,
    // @ts-expect-error TS(2339): Property 'deleteArticulo' does not exist on type '...
    deleteArticulo,
  }) => (
    <div className='articulo-selected-item'>
      <div className='wrap-image'>
        <div className='articulo-image'>
          {thumbnailBase64 ? (
            <img
              src={createImgURI(thumbnailBase64, fichero?.mediaType)}
              alt={`Imagen del artículo ${concepto}`}
            />
          ) : (
            <CameraOff />
          )}
        </div>
        <span className='ml-1'>{concepto}</span>
      </div>

      <Button
        onClick={() =>
          deleteArticulo({
            id,
            categoriaNombre: categoriaName,
          })
        }
        className='p-button-text p-button-secondary p-button-lg'
        icon='pi pi-trash'
      />
    </div>
  )
)

const ArticulosSelected = ({
  disabled,
  onHide,
  onCreate,
  labelOnAction,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    articulosSelected,
    creatingCatalogo,
    updatingCatalogo,
    catalogoSuccessCreated,
  } = useSelector(catalogosSelector)
  const manyArticulosSelected = useSelector(manyArticulosSelectedSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if (catalogoSuccessCreated) {
      onHide()
    }
  }, [onHide, catalogoSuccessCreated])

  const handleDeleteArticulo = useCallback(
    ({ id, categoriaNombre }: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type ...
      dispatch(deleteArticuloFromCategoriaSelected({ id, categoriaNombre }))
    },
    [dispatch]
  )

  return (
    <>
      <div className='wrap-articulos-selected'>
        {Object.keys(articulosSelected).length ? (
          Object.keys(articulosSelected).map((categoriaName) => {
            const { articulos = [] } = articulosSelected[categoriaName]
            return (
              <div
                key={categoriaName}
                className='articulos-selected-items'
              >
                <div className='articulo-selected-header'>
                  <p>
                    {categoriaName} ({articulos.length})
                  </p>
                </div>

                {articulos.map((articulo: $TSMigrationFixMe) => (
                  <ArticuloSelected
                    key={articulo.id}
                    categoriaName={categoriaName}
                    deleteArticulo={handleDeleteArticulo}
                    {...articulo}
                  />
                ))}
              </div>
            )
          })
        ) : (
          <h5
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {t("catalogos.editCreate.modal.noSelected")}
          </h5>
        )}
      </div>

      <div className='articulos-selected-footer'>
        <span>
          {t("catalogos.editCreate.modal.totalArticles")}{" "}
          {manyArticulosSelected}
        </span>

        <CustomButton
          disabled={disabled}
          onClick={onCreate}
          loading={creatingCatalogo || updatingCatalogo}
          className='large'
          label={labelOnAction}
        />
      </div>
    </>
  )
}

export default ArticulosSelected
